export default __webpack_public_path__ + "static/media/download-outline.6b2d4500.svg";